const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-datacenter-staging' : 'api/gp-datacenter'
const urls = {
  // 获取报告会数据
  getLiveReportViewData: 'get /api/v1/stt/liveReport/viewData',
  // 获取观看客户列表
  queryLiveReportViewRecord: 'get /api/v1/stt/liveReport/viewReport',
  //获取我的员工观看列表
  queryDepartmentViewData: 'get /api/v1/stt/liveReport/viewReport/department',
  // 直播推广详情页列表
  getLiveList: 'get /api/v1/admin/stt/content/:authorUid/live'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS